import { TReleasesStage } from './types';

export type TFeatures = 'signUp';

export const releaseStages: TReleasesStage<TFeatures> = {
  signUp: 'development', // 'off' | 'development'
};
